import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { demanderUrlConnexionQonto, messageErreur, useConnexionQonto } from './skipcarPlusApi';
import { dateFr } from './skipcarPlusFormat';

/** Message affiché au retour de la page d'accord Qonto (?qonto=…). */
const MESSAGES_RETOUR: Record<string, { texte: string; erreur: boolean }> = {
  connecte: { texte: 'Skipcar est connecté à Qonto.', erreur: false },
  refus: { texte: "L'accès a été refusé sur Qonto : rien n'a changé.", erreur: true },
  expire: { texte: 'La demande de connexion a expiré : relancez-la.', erreur: true },
  erreur: { texte: "La connexion à Qonto a échoué. Relancez-la, et prévenez l'équipe technique si ça se répète.", erreur: true },
};

/**
 * Connexion OAuth de Skipcar à Qonto (lot 5) : c'est elle qui ouvre les
 * prélèvements SEPA et les webhooks. À faire une fois, puis tous les 90 jours
 * au plus si Qonto la révoque.
 */
const ConnexionQontoCarte: React.FC = () => {
  const { data, isLoading, error } = useConnexionQonto();
  const [parametres] = useSearchParams();
  const [erreurConnexion, setErreurConnexion] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);
  const retour = MESSAGES_RETOUR[parametres.get('qonto') ?? ''];

  const connecter = async (): Promise<void> => {
    setErreurConnexion(null);
    setEnCours(true);
    try {
      window.location.assign(await demanderUrlConnexionQonto());
    } catch (connexionError) {
      setErreurConnexion(messageErreur(connexionError));
      setEnCours(false);
    }
  };

  const verificationOk = data?.verification === 'ok';

  return (
    <section className="sk-card">
      <header className="sk-card-header">
        <span className="sk-kicker">Connexion Qonto</span>
        <span className="sp-muted">prélèvements SEPA et webhooks</span>
      </header>
      <div className="sk-card-body">
        {retour && <p className={retour.erreur ? 'sp-error' : 'sp-muted'}>{retour.texte}</p>}
        {isLoading && <p className="sp-muted">Chargement…</p>}
        {error && <p className="sp-error">{messageErreur(error)}</p>}
        {data && !data.configure && <p className="sp-muted">La connexion OAuth à Qonto n'est pas configurée sur ce serveur.</p>}
        {data?.configure && (
          <div className="sp-row">
            {data.connecte ? (
              <div>
                <span className={`sk-badge ${verificationOk ? 'sk-badge-success' : 'sk-badge-danger'}`}>
                  {verificationOk ? 'Connecté' : 'À reconnecter'}
                </span>{' '}
                {data.organisation ?? 'organisation inconnue'}
                <div className="sp-muted">
                  connecté le {dateFr(data.connecteLe)}
                  {data.connectePar ? ` par ${data.connectePar}` : ''}
                  {data.renouveleLe ? ` · jeton renouvelé le ${dateFr(data.renouveleLe)}` : ''}
                </div>
                {!verificationOk && data.verification && <div className="sp-error">{data.verification}</div>}
              </div>
            ) : (
              <span className="sk-badge sk-badge-neutral">Non connecté</span>
            )}
            <button type="button" className="sk-btn sk-btn-secondary" disabled={enCours} onClick={connecter}>
              {data.connecte ? 'Reconnecter Qonto' : 'Connecter Qonto'}
            </button>
          </div>
        )}
        {erreurConnexion && <p className="sp-error">{erreurConnexion}</p>}
      </div>
    </section>
  );
};

export default ConnexionQontoCarte;
